import React, { Component, Fragment } from "react";
import { Modal, Form, Input, Spin, Radio, Select, Icon, Row, Col } from "antd";
import { inject, observer } from "mobx-react";
import co from "co";
import { RouterState, routerStateToUrl } from "mobx-state-router";
import { createLocation } from "history";
import { history } from "utils/history";
import { Guides } from "common/guides";

const FormItem = Form.Item;
const Option = Select.Option;

@Form.create({
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class AddWizardForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	getValues = () => {
		return {
			name: this.props.form.getFieldValue("name"),
			strategy: this.props.form.getFieldValue("strategy")
		};
	};

	render() {
		let strategyPart = "";

		let selectedStrategyId = this.props.form.getFieldValue("strategy");
		let imgPart = "";
		if (selectedStrategyId) {
			let strategy = this.props.strategies.find(
				strategy => strategy.id == selectedStrategyId
			);
			imgPart = (
				<img
					width={480}
					src={
						"data:image/svg+xml," + encodeURIComponent(strategy.img)
					}
				/>
			);
		}
		strategyPart = (
			<Fragment>
				<FormItem
					labelCol={{ span: 5 }}
					wrapperCol={{ span: 15 }}
					label="Strategy"
				>
					<Row gutter={8}>
						<Col span={24}>
							{this.props.form.getFieldDecorator("strategy", {
								rules: [
									{
										required: true,
										message: "Please select a strategy"
									}
								]
							})(
								<Select
									showSearch
									filterOption={(input, option) =>
										option.props.children
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
									}								
								>
									{this.props.strategies.map(item => {
										return (
											<Option key={item.id} id={item.id}>
												{item.name}
											</Option>
										);
									})}
								</Select>
							)}
						</Col>						
					</Row>
				</FormItem>
				{imgPart}
			</Fragment>
		);
		return (
			<Form>
				<FormItem
					labelCol={{ span: 5 }}
					wrapperCol={{ span: 15 }}
					label="Name"
				>
					{this.props.form.getFieldDecorator("name", {
						rules: [
							{
								required: true,
								message: "Please enter wizard name"
							}
						]
					})(<Input placeholder="My great SEO wizard" />)}
				</FormItem>
				{strategyPart}
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class AddWizardDialog extends Component {
	mapPropsToFields = () => {
		const {
			rootStore: { xwizardsStore }
		} = this.props;

		const ui = xwizardsStore.ui;

		return {
			name: Form.createFormField({
				value: undefined
			}),
			strategy: Form.createFormField({
				value: undefined
			})			
		};
	};

	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	createWizard = name => {
		const {
			rootStore: { xwizardsStore, routerStore }
		} = this.props;

		const ui = xwizardsStore.ui;

		co(
			function*() {
				const response = yield this.validateForm();
				if (response != null) return;
				const formValues = this.internalForm.getValues();

				const toState = new RouterState(
					"newWizard",
					{
						sid: formValues.strategy
					},
					{
						wizardName: formValues.name						
					}
				);
				const location = createLocation(
					routerStateToUrl(routerStore, toState)
				);
				const href = history.createHref(location);
				window.open(href, "_self");

			}.bind(this)
		);
	};

	hideDialog = () => {
		const {
			rootStore: { xwizardsStore }
		} = this.props;

		xwizardsStore.hideAddWizardDialog();
	};

	render() {
		// console.log("Rendering AddWizardDialog");
		const {
			rootStore: { xwizardsStore }
		} = this.props;

		const ui = xwizardsStore.ui;
		const strategies = xwizardsStore.strategies;

		let title = "New XWizard";

		const spinning = ui.addingWizard == true;		

		return (
			<Modal
				visible={ui.addWizardDialogVisible}
				title={title}
				okText="Save"
				onCancel={this.hideDialog}
				onOk={this.createWizard}
				width={820}
				style={{ top: 20 }}
			>
				<Spin spinning={spinning}>
					<AddWizardForm
						fields={this.mapPropsToFields()}
						strategies={strategies}
						wrappedComponentRef={internalForm => {
							this.internalForm = internalForm;
						}}
					/>
				</Spin>
			</Modal>
		);
	}
}

export default AddWizardDialog;
